module.exports = __webpack_public_path__ + "static/media/cristalli_blue.a0d8a85a.png";